import T from 'utils/T';
import ex from 'utils/ex';

export default function PatientSex(props) {
  const {
    patient,
  } = props || {};
  const {
    gender,
  } = patient;
  return (
    <div {...ex('PatientSex', props)}>
      {gender}
    </div>
  );
}
